// ------------------------------------
// Order Bump (Carrosel)
// ------------------------------------
(function () {
  'use strict';

  const $obWrp = $('.co-orderbump');
  const obPosition = $obWrp.data('position');
  const obLayout = $obWrp.data('layout');

  // Posição
  function fixPositionOb() {
    if (obPosition === 'after-resume') {
      if (isMedia('xl') || isMedia('lg')) {
        $obWrp.appendTo('.co-orderbump-resume-wrp');
      } else {
        $obWrp.appendTo('.co-orderbump-resume-mb-wrp');
      }
      $obWrp.show();
      $('.co-orderbump-carrosel').trigger('reload-ob');
    } else {
      if ($('.co-payment .collapse-item.active').length) {
        $obWrp.appendTo('.co-payment .collapse-item.active .payment-ob-wrp');
        $obWrp.show();
        $('.co-orderbump-carrosel').trigger('reload-ob');
      }
    }
  }
  fixPositionOb();
  $obWrp.on('reload-position', function () {
    fixPositionOb();
  });
  $(window).on(
    'hresize ',
    debounce(function () {
      fixPositionOb();
    }, 100),
  );

  const $carrouselOb = $('.co-orderbump-carrosel');
  const carrouselObLength = $carrouselOb.find('.carousel-item').length;
  const carrouselObDots = carrouselObLength > 1;
  const carrouselObOpts = {
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    autoplay: false,
    dots: false,
  };
  let carrouselOb;
  if (carrouselObDots) {
    $carrouselOb.addClass('with-dots');
  }
  if (carrouselObLength > 1) {
    if (LPQV.ob_layout === 'carousel') {
      $('.co-orderbump-carrosel-btns').show();
    }
    carrouselObOpts.arrows = true;
    carrouselObOpts.prevArrow = '.co-orderbump-carrosel-btns .btn-prev';
    carrouselObOpts.nextArrow = '.co-orderbump-carrosel-btns .btn-next';
  } else {
    carrouselObOpts.arrows = false;
    $('.co-orderbump-carrosel-btns').hide();
  }
  if (carrouselObLength > 1 && LPQV.ob_layout === 'carousel') {
    carrouselOb = $carrouselOb.slick(carrouselObOpts);
  }
  /* carrouselOb.on('afterChange', function (event, slick) {
    $carrouselOb.slick('resize');
  }); */

  // Reinicia o carrossel
  $carrouselOb.on('reload-ob', function () {
    if (LPQV.ob_layout === 'carousel') {
      if ($carrouselOb.hasClass('slick-slider')) {
        $carrouselOb.slick('unslick');
        carrouselOb = null;
      }
      setTimeout(() => {
        carrouselOb = $carrouselOb.slick(carrouselObOpts);
      }, 100);
    }
  });
})();

// ------------------------------------
// Order Bump
// ------------------------------------
(function () {
  'use strict';

  const urlApi = urlBase + 'core/acoes/checkout/order_bump.php';
  const orderBumpList = [];

  // Percorre todos os order bumps
  const $orderBumpItens = $('.co-orderbump-carrosel .orderbump');
  $orderBumpItens.each(function () {
    // Variáveis
    const $el = $(this);
    const $attrsEl = $el.find('.orderbump-attributes');
    const $attrInputs = $attrsEl.find('.form-input');
    const variantsList = $attrsEl.data('variants');
    const imagesList = $attrsEl.data('images');
    const $variantSKU = $el.find('.co-orderbump-variant');
    const $obImg = $el.find('.orderbump-prod-image img');
    const $orderBumpCheck = $el.find('co-orderbump-check');
    const $oderBumpBtn = $el.find('.btn-ob-act');
    const $obSubtitle = $el.find('.orderbump-prod-subtitle');
    const $orderBumpError = $el.find('.orderbump-error');

    // Ao alterar os atributos
    $attrInputs.on('change', function () {
      if ($(this).hasClass('form-input-kit')) {
        showVariantInfos('', $(this).val());
      } else {
        getAttrVariant();
      }
    });

    // Exibe as informações da variante selecionada
    function showVariantInfos(variantSlug, variantSKU = false) {
      let variant;
      if (variantSKU) {
        variant = getVariantBySKU(variantSKU);
      } else {
        variant = getVariant(variantSlug);
      }
      if (variant !== undefined) {
        hideObError();
        //console.log(variant);
        console.log('Variante: ' + variant.sku);
        // SKU
        $variantSKU.val(variant.sku);
        $oderBumpBtn.data('variant', variant.sku);
        // Imagem
        const obImage = getImgVariant(variant.image_id);
        if (obImage) {
          $obImg.attr('src', obImage.thumb);
          $oderBumpBtn.data('image', obImage.thumb);
        }
        // Subtítulo (Informação da variante)
        $obSubtitle.text(variant.title_view);
        $oderBumpBtn.data('subtitle', variant.title_view);
        // Verifica disponibilidade
        if (variant.automatic_stock == '1' && variant.quantity == 0) {
          //$('.orderbump-btn').addClass('disabled');
          $oderBumpBtn.prop('disabled', true);
          showObError('Opção indisponível! Selecione uma opção diferente.');
        } else {
          //$('.orderbump-btn').removeClass('disabled');
          $oderBumpBtn.prop('disabled', false);
          hideObError();
        }
      }
      slickFixHeight($('.co-orderbump-carrosel'));
    }

    // Retorna uma variante com base no slug
    function getVariant(variantSlug) {
      return variantsList.filter((item) => item.slug == variantSlug)[0];
    }

    // Retorna uma variante com base no SKU
    function getVariantBySKU(variantSKU) {
      return variantsList.filter((item) => item.sku == variantSKU)[0];
    }

    // Retorna a imagem da variante
    function getImgVariant(imageID) {
      return imagesList.filter((item) => item.id == imageID)[0];
    }

    // Retorna o slug da variante com base nos atributos selecionados
    function getAttrVariant() {
      let variantSlug = [];
      $attrInputs.each(function () {
        const $input = $(this);
        const attrName = $input.data('name');
        const attrValue = slugify($input.val());
        variantSlug.push(attrName + ':' + attrValue);
      });
      variantSlug = variantSlug.join('|');
      showVariantInfos(variantSlug);
    }

    function showObError(error) {
      $orderBumpError.find('li').html(error);
      $orderBumpError.show();
    }

    function hideObError() {
      $orderBumpError.find('li').html('');
      $orderBumpError.hide();
    }
  });

  function verificaAtributos($obEl) {
    const $orderBumpError = $obEl.find('.orderbump-error');
    const $attrInputs = $obEl.find('.orderbump-attributes .form-input');
    let empty = 0;

    function showObError(error) {
      $orderBumpError.find('li').html(error);
      $orderBumpError.show();
    }

    function hideObError() {
      $orderBumpError.find('li').html('');
      $orderBumpError.hide();
    }

    $attrInputs.each(function () {
      const $input = $(this);
      if ($input.val() === '') {
        empty++;
      }
    });

    if (empty > 0) {
      showObError('Selecione as opções para o produto.');
      slickFixHeight($('.co-orderbump-carrosel'));
      return false;
    } else {
      hideObError();
      slickFixHeight($('.co-orderbump-carrosel'));
      return true;
    }
  }

  // Evento do botão para adicionar ou remover o order bump
  $('body').on('click', '.btn-ob-act', function (ev) {
    ev.preventDefault();
    const $obBtn = $(this);
    const obAction = $obBtn.data('action');
    const obID = $obBtn.data('ob');
    const variantSKU = $obBtn.data('variant');
    const $obEl = $('#orderbump-' + obID);

    // Adiciona
    if (obAction === 'insert') {
      if (verificaAtributos($obEl)) {
        addOrderBump(obID, variantSKU);
      }
    }
    // Remove
    else if (obAction === 'remove') {
      const cartItemID = $obBtn.attr('data-item-cart');
      removeOrderBump(obID, cartItemID);
    }
  });

  // Adiciona um order bump
  function addOrderBump(obID, variantSKU) {
    const $obEl = $('#orderbump-' + obID);
    const $obLoader = $obEl.find('.orderbump-loader');
    $('.shipping-quantity-loader').show();
    console.log('Save from: orderbump add');
    saveCheckout(
      'order_bump_insert',
      {
        orderbump: obID,
        orderbump_variant: variantSKU,
      },
      function () {
        const resp = arguments[0];
        console.log(resp);
        const cartItemID = resp.prod.id;
        $('.shipping-quantity-loader').hide();
        const $resumeItens = $('.co-resume-items');
        const $obElBtn = $obEl.find('.btn-ob-act');
        const title = $obElBtn.data('title');
        let subtitle = $obElBtn.data('subtitle');
        subtitle = subtitle ? subtitle : '';
        const image = $obElBtn.data('image');
        const quantity = $obElBtn.data('quantity');
        const subtotal = $obElBtn.data('subtotal');
        const subtotalRS = formatMoneyBR(subtotal);
        const $obItem = `
        <li class="co-r-item co-r-item-orderbump" data-ob="${obID}">
          <div class="co-r-item-wrp">
            <figure class="co-r-item-image">
              <img src="${image}" alt="${title}">
            </figure>
            <div class="co-r-item-infos">
              <h2 class="co-r-item-title">${title}</h2>
              <p>${subtitle}</p>
              <div class="co-r-item-actions">
                <div class="co-r-item-price">R$ ${subtotalRS}</div>
                <a href="#" class="link-danger remove-orderbump btn-ob-act" data-ob="${obID}" data-item-cart="${cartItemID}" data-action="remove" data-tippy-content="Remover" data-tippy-placement="bottom"><i class="las la-trash"></i></a>
              </div>
            </div>
          </div>
        </li>`;
        $resumeItens.append($obItem);
        orderBumpList.push({
          id: obID,
          value: subtotal,
        });
        saveOption('orderbump', orderBumpList);
        //$('#co-zipcode').trigger('change-coupon');
        $('.shipping_ways').trigger('change-cart');
        calcCheckout();
        initCoTooltip();
        disableAttrOrderBump($obEl);
        handleStateBtn($obElBtn, 'insert', cartItemID);
        if ($('.co-orderbump-carrosel .orderbump').length > 0) {
          $('.co-orderbump-carrosel').slick('slickNext');
        }
      },
      $obLoader,
    );
  }

  // Remove um order bump
  function removeOrderBump(obID, cartItemID) {
    const $obEl = $('#orderbump-' + obID);
    const $obLoader = $obEl.find('.orderbump-loader');
    $('.shipping-quantity-loader').show();
    console.log('Save from: orderbump remove');
    saveCheckout(
      'order_bump_remove',
      {
        order_bump_id: obID,
        cart_item: cartItemID,
      },
      function () {
        $('.shipping-quantity-loader').hide();
        const $resumeItens = $('.co-resume-items');
        const $obElBtn = $obEl.find('.btn-ob-act');
        const $resumeItensItem = $resumeItens.find('.co-r-item-orderbump[data-ob="' + obID + '"]');
        $resumeItensItem.find('.remove-orderbump')[0]._tippy.destroy();
        $resumeItensItem.remove();
        const indexRemove = orderBumpList.findIndex((item) => item.id == obID);
        orderBumpList.splice(indexRemove, 1);
        saveOption('orderbump', orderBumpList);
        //$('#co-zipcode').trigger('change-coupon');
        $('.shipping_ways').trigger('change-cart');
        calcCheckout();
        enableAttrOrderBump($obEl);
        handleStateBtn($obElBtn, 'remove');
      },
      $obLoader,
    );
  }

  // Remove todos order bumps
  $('body').on('ob-rem-all', function (ev) {
    $('.co-r-item.co-r-item-orderbump .remove-orderbump').each(function () {
      const obID = $(this).data('ob');
      const cartItemID = $(this).data('item-cart');
      setTimeout(() => {
        removeOrderBump(obID, cartItemID);
      }, 100);
    });
  });

  // Altera o estado do botão do order bump para venda ou remoção
  function handleStateBtn($btn, btnAction, cartItemID = false) {
    if (btnAction === 'insert') {
      $btn
        .data('action', 'remove')
        .attr('data-item-cart', cartItemID)
        .removeClass('btn-primary')
        .addClass('btn-grey')
        .html('<i class="las la-trash"></i> Remover oferta');
    }
    if (btnAction === 'remove') {
      $btn
        .data('action', 'insert')
        .removeClass('btn-grey')
        .addClass('btn-primary')
        .data('cart-item', 0)
        .html($btn.data('txt-default'));
    }
  }

  // Desabilita os campos de um order bump
  function disableAttrOrderBump($obEl) {
    const $attrInputs = $obEl.find('.orderbump-attributes .form-input');
    $attrInputs.each(function () {
      $(this).addClass('disabled');
    });
  }

  // Habilita os campos de um order bump
  function enableAttrOrderBump($obEl) {
    const $attrInputs = $obEl.find('.orderbump-attributes .form-input');
    $attrInputs.each(function () {
      $(this).removeClass('disabled');
    });
  }

  // Carrega os orders bums do carrinho ao carregar a página
  function loadOrderBumps() {
    $('.co-resume-items .co-r-item-orderbump').each(function () {
      const $el = $(this);
      const obID = $el.data('ob');
      orderBumpList.push({
        id: obID,
        value: $el.data('price'),
      });
      const $obEl = $('#orderbump-' + obID);
      const $obBtn = $obEl.find('.orderbump-btn .btn');
      if ($obBtn.length) {
        const obCartId = $el.find('[data-item-cart]').data('item-cart');
        disableAttrOrderBump($obEl);
        handleStateBtn($obBtn, 'insert', obCartId);
        initCoTooltip();
      }
    });
    saveOption('orderbump', orderBumpList);
    calcCheckout();
  }
  if ($('.co-resume-items .co-r-item-orderbump').length > 0) {
    loadOrderBumps();
  }
})();
